module.exports = ".logout-btn {\n  background-color: Transparent;\n  background-repeat: no-repeat;\n  border: none;\n  cursor: pointer;\n  overflow: hidden;\n  outline: none;\n  color: #fff; }\n\n.navbar-brand {\n  margin-right: 2rem;\n  font-size: 18px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main